export interface AdjustmentCouponUse {
    item: string
    category: string
    number: number
    charge: number
}
export interface ObjectToAdjustmentCouponUseProps {
    item: string
    category: string
    number: number | string
    charge: number | string
}
export const ObjectToAdjustmentCouponUse = (obj: ObjectToAdjustmentCouponUseProps): AdjustmentCouponUse => {
    return {
        item: obj.item,
        category: obj.category,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
    }
}